module.exports = __webpack_public_path__ + "static/media/wingAndSticker.d21f3e01.png";